import { useQueryClient } from '@tanstack/react-query';
import type { ProgramConferenceOrWebinarFeedback } from 'models';
import { useMutation } from 'query';
import { createEventFeedback } from '../../services';
import { getEventsQueryKey } from '../keys';

export const useCreateEventFeedback = () => {
  const queryClient = useQueryClient();

  return useMutation<undefined, { data: ProgramConferenceOrWebinarFeedback; id: string }>({
    async mutationFn({ data, id }) {
      const response = await createEventFeedback(id, createRequestData(data));

      return response.data;
    },
    async onError() {
      await queryClient.invalidateQueries({ queryKey: getEventsQueryKey({}) });
    },
  });
};

const createRequestData = (data: ProgramConferenceOrWebinarFeedback) => ({
  /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
  audio_rating: data.isAudioOk,
  audio_text: data.audioText,
  helpful_rating: data.isHelpful,
  helpful_text: data.helpfulText,
  video_rating: data.isVideoOk,
  video_text: data.videoText,
  /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
});
